import React from 'react';

import AddressChecksum from "./AddressChecksum";
import ContractAddress from "./ContractAddress";
import KeyToAddress from "./KeyToAddress";
import RecoverAddress from "./RecoverAddress";
import RLP from "./RLP";
import Transaction from "./Transaction";

import ToolPanel from "../component/ToolPanel";

function Ethereum (props) {
  return (
    <>
      <ToolPanel title="Address Checksum"
                 tag="address-checksum">
        <AddressChecksum />
      </ToolPanel>
      <ToolPanel title="Contract Address"
                 tag="contract-address">
        <ContractAddress />
      </ToolPanel>
      <ToolPanel title="Key to Address"
                 tag="key-to-address">
        <KeyToAddress />
      </ToolPanel>
      <ToolPanel title="Recover address"
                 tag="recover-address">
        <RecoverAddress />
      </ToolPanel>
      <ToolPanel title="RLP"
                 tag="rlp">
        <RLP />
      </ToolPanel>
      <ToolPanel title="Transaction"
                 tag="transaction">
        <Transaction />
      </ToolPanel>
    </>
  );
}

export default Ethereum;
